import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";

export interface DividerProps extends ComponentPropsWithoutRef<"div"> {
  className?: string;
}

export const HeaderDivider = ({ className, ...rest }: DividerProps) => (
  <div
    className={classNames("bg-overlay-dark ml-5 mr-6 h-7 w-px", className)}
    {...rest}
  />
);
